import { request } from './index'
import config from '@/config'

const questionsBankRequest = (method, url, params) => {
  console.log(config)
  return request(method, url, params, config.mainApps.questionsBank, config.mainApps.questionsBank.baseURL)
}

export { questionsBankRequest }
